export const INITIAL_FILTER_STATE = {
  category: 'schools',
  search: '',
  ordering: 'name',

  intel_dev: false,
  sport_dev: false,
  create_dev: false,
  music_dev: false,
  preparing_for_school: false,

  working_hours: [],
  group_size: [],
  age_category: [],

  profile: [],
  classes: [],

  languages: [],
  area: [],
  underground: [],
  price: {
    minVal: 0,
    maxVal: 500000,
  },
};

export const NAV_CATEGORY = [
  { name: 'Школы', category: 'schools' },
  { name: 'Сады', category: 'kindergartens' },
];

export const sortButtons = [
  { title: 'По названию', id: 'name' },
  { title: 'По стоимости', id: 'price' },
  { title: 'По отзывам', id: 'reviews_count' },
  { title: 'По рейтингу', id: 'rating' },
];

export const METRO_LIST = [
  'Авиамоторная',
  'Автозаводская',
  'Академическая',
  'Александровский сад',
  'Алексеевская',
  'Алма-Атинская',
  'Алтуфьево',
  'Аннино',
  'Арбатская',
  'Аэропорт',
  'Бабушкинская',
  'Багратионовская',
  'Баррикадная',
  'Бауманская',
  'Беговая',
  'Беломорская',
  'Белорусская',
  'Беляево',
  'Бибирево',
  'Библиотека имени Ленина',
  'Битцевский парк',
  'Борисово',
  'Боровицкая',
  'Боровское шоссе',
  'Ботанический сад',
  'Братиславская',
  'Бульвар адмирала Ушакова',
  'Бульвар Дмитрия Донского',
  'Бульвар Рокоссовского',
  'Бунинская аллея',
  'Бутырская',
  'Варшавская',
  'ВДНХ',
  'Верхние Лихоборы',
  'Владыкино',
  'Водный стадион',
  'Войковская',
  'Волгоградский проспект',
  'Волжская',
  'Волоколамская',
  'Воробьевы горы',
  'Выставочная',
  'Выхино',
  'Говорово',
  'Деловой центр',
  'Динамо',
  'Дмитровская',
  'Добрынинская',
  'Домодедовская',
  'Достоевская',
  'Дубровка',
  'Жулебино',
  'Зябликово',
  'Измайловская',
  'Калужская',
  'Кантемировская',
  'Каховская',
  'Каширская',
  'Киевская',
  'Китай-город',
  'Кожуховская',
  'Коломенская',
  'Коммунарка',
  'Комсомольская',
  'Коньково',
  'Косино',
  'Котельники',
  'Красногвардейская',
  'Краснопресненская',
  'Красносельская',
  'Красные ворота',
  'Крестьянская застава',
  'Кропоткинская',
  'Крылатское',
  'Кузнецкий мост',
  'Кузьминки',
  'Кунцевская',
  'Курская',
  'Кутузовская',
  'Ленинский проспект',
  'Лермонтовский проспект',
  'Лесопарковая',
  'Лефортово',
  'Ломоносовский проспект',
  'Лубянка',
  'Лухмановская',
  'Люблино',
  'Марксистская',
  'Марьина роща',
  'Марьино',
  'Маяковская',
  'Медведково',
  'Международная',
  'Менделеевская',
  'Минская',
  'Митино',
  'Мичуринский проспект',
  'Молодежная',
  'Мякинино',
  'Нагатинская',
  'Нагорная',
  'Нахимовский проспект',
  'Некрасовка',
  'Нижегородская',
  'Новогиреево',
  'Новокосино',
  'Новокузнецкая',
  'Новопеределкино',
  'Новослободская',
  'Новоясеневская',
  'Новые Черемушки',
  'Озерная',
  'Окружная',
  'Окская',
  'Октябрьская',
  'Октябрьское поле',
  'Ольховая',
  'Орехово',
  'Отрадное',
  'Охотный ряд',
  'Павелецкая',
  'Парк культуры',
  'Парк Победы',
  'Партизанская',
  'Первомайская',
  'Перово',
  'Петровский парк',
  'Петровско-Разумовская',
  'Печатники',
  'Пионерская',
  'Планерная',
  'Площадь Ильича',
  'Площадь Революции',
  'Полежаевская',
  'Полянка',
  'Пражская',
  'Преображенская площадь',
  'Прокшино',
  'Пролетарская',
  'Проспект Вернадского',
  'Проспект Мира',
  'Профсоюзная',
  'Пушкинская',
  'Пятницкое шоссе',
  'Раменки',
  'Рассказовка',
  'Речной вокзал',
  'Рижская',
  'Римская',
  'Румянцево',
  'Рязанский проспект',
  'Савеловская',
  'Саларьево',
  'Свиблово',
  'Севастопольская',
  'Селигерская',
  'Семеновская',
  'Серпуховская',
  'Славянский бульвар',
  'Смоленская',
  'Сокол',
  'Сокольники',
  'Солнцево',
  'Спартак',
  'Спортивная',
  'Сретенский бульвар',
  'Станклово',
  'Строгино',
  'Студенческая',
  'Сухаревская',
  'Сходненская',
  'Таганская',
  'Тверская',
  'Театральная',
  'Текстильщики',
  'Теплый Стан',
  'Технопарк',
  'Тимирязевская',
  'Третьяковская',
  'Тропарево',
  'Трубная',
  'Тульская',
  'Тургеневская',
  'Тушинская',
  'Улица 1905 года',
  'Улица академика Янгеля',
  'Улица Горчакова',
  'Улица Дмитриевского',
  'Улица Скобелевская',
  'Улица Старокачаловская',
  'Университет',
  'Филатов луг',
  'Филевский парк',
  'Фили',
  'Фонвизинская',
  'Фрунзенская',
  'Ховрино',
  'Хорошевская',
  'Царицыно',
  'Цветной бульвар',
  'ЦСКА',
  'Черкизовская',
  'Чертановская',
  'Чеховская',
  'Чистые пруды',
  'Чкаловская',
  'Шаболовская',
  'Шелепиха',
  'Шипиловская',
  'Шоссе Энтузиастов',
  'Щелковская',
  'Щукинская',
  'Электрозаводская',
  'Юго-Восточная',
  'Юго-Западная',
  'Южная',
  'Ясенево',
];

export const METRO_COLOR_LIST = [
  {
    id: '8',
    hex_color: 'FFCD1C',
    name: 'Калининская',
    stations: [
      {
        id: '8.189',
        name: 'Новокосино',
        lat: 55.745113,
        lng: 37.864052,
        order: 0,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.88',
        name: 'Новогиреево',
        lat: 55.752237,
        lng: 37.814587,
        order: 1,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.107',
        name: 'Перово',
        lat: 55.75098,
        lng: 37.78422,
        order: 2,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.158',
        name: 'Шоссе Энтузиастов',
        lat: 55.75809,
        lng: 37.751703,
        order: 3,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.1',
        name: 'Авиамоторная',
        lat: 55.751933,
        lng: 37.717444,
        order: 4,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.112',
        name: 'Площадь Ильича',
        lat: 55.747115,
        lng: 37.680726,
        order: 5,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.78',
        name: 'Марксистская',
        lat: 55.740746,
        lng: 37.65604,
        order: 6,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
      {
        id: '8.91',
        name: 'Третьяковская',
        lat: 55.741125,
        lng: 37.626142,
        order: 7,
        line: {
          id: '8',
          hex_color: 'FFCD1C',
          name: 'Калининская',
        },
      },
    ],
  },
  {
    id: '2',
    hex_color: '4FB04F',
    name: 'Замоскворецкая',
    stations: [
      {
        id: '2.558',
        name: 'Ховрино',
        lat: 55.8777,
        lng: 37.4877,
        order: 0,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.674',
        name: 'Беломорская',
        lat: 55.8651,
        lng: 37.4764,
        order: 1,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.125',
        name: 'Речной вокзал',
        lat: 55.854152,
        lng: 37.476728,
        order: 2,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.29',
        name: 'Водный стадион',
        lat: 55.838978,
        lng: 37.487515,
        order: 3,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.30',
        name: 'Войковская',
        lat: 55.818923,
        lng: 37.497791,
        order: 4,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.133',
        name: 'Сокол',
        lat: 55.805564,
        lng: 37.515245,
        order: 5,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.12',
        name: 'Аэропорт',
        lat: 55.800441,
        lng: 37.530477,
        order: 6,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.34',
        name: 'Динамо',
        lat: 55.789704,
        lng: 37.558212,
        order: 7,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.19',
        name: 'Белорусская',
        lat: 55.777439,
        lng: 37.582107,
        order: 8,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.80',
        name: 'Маяковская',
        lat: 55.769808,
        lng: 37.596192,
        order: 9,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.122',
        name: 'Тверская',
        lat: 55.765343,
        lng: 37.603918,
        order: 10,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.99',
        name: 'Театральная',
        lat: 55.758808,
        lng: 37.61768,
        order: 11,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.89',
        name: 'Новокузнецкая',
        lat: 55.742391,
        lng: 37.62928,
        order: 12,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.101',
        name: 'Павелецкая',
        lat: 55.729741,
        lng: 37.638693,
        order: 13,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.2',
        name: 'Автозаводская',
        lat: 55.706634,
        lng: 37.657008,
        order: 14,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.512',
        name: 'Технопарк',
        lat: 55.695,
        lng: 37.664167,
        order: 15,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.53',
        name: 'Коломенская',
        lat: 55.677423,
        lng: 37.663719,
        order: 16,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.45',
        name: 'Каширская',
        lat: 55.655745,
        lng: 37.649683,
        order: 17,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.42',
        name: 'Кантемировская',
        lat: 55.636107,
        lng: 37.656218,
        order: 18,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.153',
        name: 'Царицыно',
        lat: 55.620982,
        lng: 37.669612,
        order: 19,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.96',
        name: 'Орехово',
        lat: 55.61269,
        lng: 37.695214,
        order: 20,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.38',
        name: 'Домодедовская',
        lat: 55.610131,
        lng: 37.717111,
        order: 21,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.57',
        name: 'Красногвардейская',
        lat: 55.614075,
        lng: 37.742697,
        order: 22,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
      {
        id: '2.257',
        name: 'Алма-Атинская',
        lat: 55.63349,
        lng: 37.765678,
        order: 23,
        line: {
          id: '2',
          hex_color: '4FB04F',
          name: 'Замоскворецкая',
        },
      },
    ],
  },
  {
    id: '6',
    hex_color: 'F07E24',
    name: 'Калужско-Рижская',
    stations: [
      {
        id: '6.81',
        name: 'Медведково',
        lat: 55.888103,
        lng: 37.661562,
        order: 0,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.13',
        name: 'Бабушкинская',
        lat: 55.870641,
        lng: 37.664341,
        order: 1,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.129',
        name: 'Свиблово',
        lat: 55.855558,
        lng: 37.653379,
        order: 2,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.24',
        name: 'Ботанический сад',
        lat: 55.844597,
        lng: 37.637811,
        order: 3,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.27',
        name: 'ВДНХ',
        lat: 55.819626,
        lng: 37.640751,
        order: 4,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.8',
        name: 'Алексеевская',
        lat: 55.807794,
        lng: 37.638699,
        order: 5,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.126',
        name: 'Рижская',
        lat: 55.792494,
        lng: 37.636114,
        order: 6,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.120',
        name: 'Проспект Мира',
        lat: 55.781827,
        lng: 37.633199,
        order: 7,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.137',
        name: 'Сухаревская',
        lat: 55.772315,
        lng: 37.63285,
        order: 8,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.144',
        name: 'Тургеневская',
        lat: 55.765371,
        lng: 37.636732,
        order: 9,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.50',
        name: 'Китай-город',
        lat: 55.756498,
        lng: 37.631326,
        order: 10,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.90',
        name: 'Третьяковская',
        lat: 55.74073,
        lng: 37.625624,
        order: 11,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.94',
        name: 'Октябрьская',
        lat: 55.731232,
        lng: 37.612851,
        order: 12,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.157',
        name: 'Шаболовская',
        lat: 55.718828,
        lng: 37.607892,
        order: 13,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.74',
        name: 'Ленинский проспект',
        lat: 55.70678,
        lng: 37.58499,
        order: 14,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.3',
        name: 'Академическая',
        lat: 55.687147,
        lng: 37.5723,
        order: 15,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.121',
        name: 'Профсоюзная',
        lat: 55.677671,
        lng: 37.562595,
        order: 16,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.92',
        name: 'Новые Черемушки',
        lat: 55.670077,
        lng: 37.554493,
        order: 17,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.41',
        name: 'Калужская',
        lat: 55.656682,
        lng: 37.540075,
        order: 18,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.21',
        name: 'Беляево',
        lat: 55.642357,
        lng: 37.526115,
        order: 19,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.56',
        name: 'Коньково',
        lat: 55.631857,
        lng: 37.519156,
        order: 20,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.140',
        name: 'Теплый Стан',
        lat: 55.61873,
        lng: 37.505912,
        order: 21,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.164',
        name: 'Ясенево',
        lat: 55.606182,
        lng: 37.5334,
        order: 22,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
      {
        id: '6.23',
        name: 'Новоясеневская',
        lat: 55.601947,
        lng: 37.553017,
        order: 23,
        line: {
          id: '6',
          hex_color: 'F07E24',
          name: 'Калужско-Рижская',
        },
      },
    ],
  },
  {
    id: '1',
    hex_color: 'E42313',
    name: 'Сокольническая',
    stations: [
      {
        id: '1.148',
        name: 'Бульвар Рокоссовского',
        lat: 55.814916,
        lng: 37.732227,
        order: 0,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.155',
        name: 'Черкизовская',
        lat: 55.802787,
        lng: 37.744863,
        order: 1,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.117',
        name: 'Преображенская площадь',
        lat: 55.796322,
        lng: 37.713582,
        order: 2,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.134',
        name: 'Сокольники',
        lat: 55.789282,
        lng: 37.679895,
        order: 3,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.60',
        name: 'Красносельская',
        lat: 55.780014,
        lng: 37.666097,
        order: 4,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.54',
        name: 'Комсомольская',
        lat: 55.774072,
        lng: 37.654565,
        order: 5,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.61',
        name: 'Красные ворота',
        lat: 55.768307,
        lng: 37.6478,
        order: 6,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.143',
        name: 'Чистые пруды',
        lat: 55.76499,
        lng: 37.638293,
        order: 7,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.66',
        name: 'Лубянка',
        lat: 55.759889,
        lng: 37.625336,
        order: 8,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.98',
        name: 'Охотный ряд',
        lat: 55.757228,
        lng: 37.615078,
        order: 9,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.4',
        name: 'Библиотека им.Ленина',
        lat: 55.752123,
        lng: 37.610388,
        order: 10,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.64',
        name: 'Кропоткинская',
        lat: 55.745297,
        lng: 37.604217,
        order: 11,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.103',
        name: 'Парк культуры',
        lat: 55.736163,
        lng: 37.595027,
        order: 12,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.152',
        name: 'Фрунзенская',
        lat: 55.727462,
        lng: 37.58022,
        order: 13,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.135',
        name: 'Спортивная',
        lat: 55.722388,
        lng: 37.562041,
        order: 14,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.165',
        name: 'Воробьевы горы',
        lat: 55.709169,
        lng: 37.557293,
        order: 15,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.149',
        name: 'Университет',
        lat: 55.69329,
        lng: 37.534511,
        order: 16,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.118',
        name: 'Проспект Вернадского',
        lat: 55.676549,
        lng: 37.504584,
        order: 17,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.162',
        name: 'Юго-Западная',
        lat: 55.663146,
        lng: 37.482852,
        order: 18,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.505',
        name: 'Тропарево',
        lat: 55.6459,
        lng: 37.4725,
        order: 19,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.513',
        name: 'Румянцево',
        lat: 55.633,
        lng: 37.4419,
        order: 20,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.514',
        name: 'Саларьево',
        lat: 55.6227,
        lng: 37.424,
        order: 21,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.678',
        name: 'Филатов луг',
        lat: 55.5997,
        lng: 37.4075,
        order: 22,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.679',
        name: 'Прокшино',
        lat: 55.5813,
        lng: 37.4425,
        order: 23,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.680',
        name: 'Ольховая',
        lat: 55.5692,
        lng: 37.4589,
        order: 24,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
      {
        id: '1.681',
        name: 'Коммунарка',
        lat: 55.559765,
        lng: 37.468716,
        order: 25,
        line: {
          id: '1',
          hex_color: 'E42313',
          name: 'Сокольническая',
        },
      },
    ],
  },
  {
    id: '3',
    hex_color: '0072BA',
    name: 'Арбатско-Покровская',
    stations: [
      {
        id: '3.159',
        name: 'Щелковская',
        lat: 55.809962,
        lng: 37.798261,
        order: 0,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.106',
        name: 'Первомайская',
        lat: 55.794376,
        lng: 37.799364,
        order: 1,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.40',
        name: 'Измайловская',
        lat: 55.787713,
        lng: 37.779896,
        order: 2,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.105',
        name: 'Партизанская',
        lat: 55.788401,
        lng: 37.74882,
        order: 3,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.130',
        name: 'Семеновская',
        lat: 55.783096,
        lng: 37.719289,
        order: 4,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.161',
        name: 'Электрозаводская',
        lat: 55.782057,
        lng: 37.7053,
        order: 5,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.17',
        name: 'Бауманская',
        lat: 55.772405,
        lng: 37.67904,
        order: 6,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.70',
        name: 'Курская',
        lat: 55.758564,
        lng: 37.659039,
        order: 7,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.100',
        name: 'Площадь Революции',
        lat: 55.756741,
        lng: 37.62236,
        order: 8,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.5',
        name: 'Арбатская',
        lat: 55.752312,
        lng: 37.60349,
        order: 9,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.131',
        name: 'Смоленская',
        lat: 55.747713,
        lng: 37.583802,
        order: 10,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.47',
        name: 'Киевская',
        lat: 55.743117,
        lng: 37.564132,
        order: 11,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.173',
        name: 'Парк Победы',
        lat: 55.735679,
        lng: 37.516865,
        order: 12,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.176',
        name: 'Славянский бульвар',
        lat: 55.729542,
        lng: 37.470973,
        order: 13,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.69',
        name: 'Кунцевская',
        lat: 55.730673,
        lng: 37.446522,
        order: 14,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.84',
        name: 'Молодежная',
        lat: 55.741375,
        lng: 37.415627,
        order: 15,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.65',
        name: 'Крылатское',
        lat: 55.756842,
        lng: 37.408139,
        order: 16,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.174',
        name: 'Строгино',
        lat: 55.803831,
        lng: 37.402405,
        order: 17,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.181',
        name: 'Мякинино',
        lat: 55.823342,
        lng: 37.385214,
        order: 18,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.182',
        name: 'Волоколамская',
        lat: 55.835154,
        lng: 37.382453,
        order: 19,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.183',
        name: 'Митино',
        lat: 55.846098,
        lng: 37.36122,
        order: 20,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
      {
        id: '3.463',
        name: 'Пятницкое шоссе',
        lat: 55.853634,
        lng: 37.353108,
        order: 21,
        line: {
          id: '3',
          hex_color: '0072BA',
          name: 'Арбатско-Покровская',
        },
      },
    ],
  },
  {
    id: '4',
    hex_color: '1EBCEF',
    name: 'Филевская',
    stations: [
      {
        id: '4.471',
        name: 'Кунцевская',
        lat: 55.730815,
        lng: 37.446754,
        order: 0,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.110',
        name: 'Пионерская',
        lat: 55.736027,
        lng: 37.466728,
        order: 1,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.150',
        name: 'Филевский парк',
        lat: 55.739665,
        lng: 37.483902,
        order: 2,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.14',
        name: 'Багратионовская',
        lat: 55.743544,
        lng: 37.497042,
        order: 3,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.151',
        name: 'Фили',
        lat: 55.746763,
        lng: 37.514035,
        order: 4,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.73',
        name: 'Кутузовская',
        lat: 55.740544,
        lng: 37.5341,
        order: 5,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.136',
        name: 'Студенческая',
        lat: 55.738761,
        lng: 37.54842,
        order: 6,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.48',
        name: 'Киевская',
        lat: 55.743168,
        lng: 37.565425,
        order: 7,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.132',
        name: 'Смоленская',
        lat: 55.749083,
        lng: 37.582173,
        order: 8,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.11',
        name: 'Арбатская',
        lat: 55.752122,
        lng: 37.601553,
        order: 9,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.6',
        name: 'Александровский сад',
        lat: 55.752255,
        lng: 37.608775,
        order: 10,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.172',
        name: 'Выставочная',
        lat: 55.750243,
        lng: 37.542641,
        order: 11,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
      {
        id: '4.179',
        name: 'Международная',
        lat: 55.748324,
        lng: 37.533282,
        order: 12,
        line: {
          id: '4',
          hex_color: '1EBCEF',
          name: 'Филевская',
        },
      },
    ],
  },
  {
    id: '9',
    hex_color: 'ADACAC',
    name: 'Серпуховско-Тимирязевская',
    stations: [
      {
        id: '9.9',
        name: 'Алтуфьево',
        lat: 55.899034,
        lng: 37.586473,
        order: 0,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.22',
        name: 'Бибирево',
        lat: 55.883868,
        lng: 37.603011,
        order: 1,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.97',
        name: 'Отрадное',
        lat: 55.864273,
        lng: 37.605066,
        order: 2,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.28',
        name: 'Владыкино',
        lat: 55.848236,
        lng: 37.590451,
        order: 3,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.108',
        name: 'Петровско-Разумовская',
        lat: 55.836565,
        lng: 37.575512,
        order: 4,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.141',
        name: 'Тимирязевская',
        lat: 55.81866,
        lng: 37.574498,
        order: 5,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.35',
        name: 'Дмитровская',
        lat: 55.808056,
        lng: 37.581734,
        order: 6,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.128',
        name: 'Савёловская',
        lat: 55.794054,
        lng: 37.587163,
        order: 7,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.83',
        name: 'Менделеевская',
        lat: 55.781999,
        lng: 37.599141,
        order: 8,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.154',
        name: 'Цветной бульвар',
        lat: 55.771653,
        lng: 37.620466,
        order: 9,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.123',
        name: 'Чеховская',
        lat: 55.765747,
        lng: 37.608493,
        order: 10,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.7',
        name: 'Боровицкая',
        lat: 55.750399,
        lng: 37.60934,
        order: 11,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.115',
        name: 'Полянка',
        lat: 55.736795,
        lng: 37.618594,
        order: 12,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.37',
        name: 'Серпуховская',
        lat: 55.726548,
        lng: 37.624792,
        order: 13,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.142',
        name: 'Тульская',
        lat: 55.70961,
        lng: 37.622569,
        order: 14,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.85',
        name: 'Нагатинская',
        lat: 55.682099,
        lng: 37.620917,
        order: 15,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.86',
        name: 'Нагорная',
        lat: 55.672962,
        lng: 37.610397,
        order: 16,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.87',
        name: 'Нахимовский проспект',
        lat: 55.662379,
        lng: 37.605274,
        order: 17,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.43',
        name: 'Севастопольская',
        lat: 55.651451,
        lng: 37.59809,
        order: 18,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.156',
        name: 'Чертановская',
        lat: 55.640538,
        lng: 37.606065,
        order: 19,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.163',
        name: 'Южная',
        lat: 55.622436,
        lng: 37.609047,
        order: 20,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.116',
        name: 'Пражская',
        lat: 55.610962,
        lng: 37.602386,
        order: 21,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.147',
        name: 'Улица Академика Янгеля',
        lat: 55.596753,
        lng: 37.601498,
        order: 22,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.10',
        name: 'Аннино',
        lat: 55.583477,
        lng: 37.596999,
        order: 23,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
      {
        id: '9.170',
        name: 'Бульвар Дмитрия Донского',
        lat: 55.568201,
        lng: 37.576856,
        order: 24,
        line: {
          id: '9',
          hex_color: 'ADACAC',
          name: 'Серпуховско-Тимирязевская',
        },
      },
    ],
  },
  {
    id: '7',
    hex_color: '943E90',
    name: 'Таганско-Краснопресненская',
    stations: [
      {
        id: '7.111',
        name: 'Планерная',
        lat: 55.859676,
        lng: 37.436808,
        order: 0,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.138',
        name: 'Сходненская',
        lat: 55.84926,
        lng: 37.44076,
        order: 1,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.145',
        name: 'Тушинская',
        lat: 55.825479,
        lng: 37.437024,
        order: 2,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.507',
        name: 'Спартак',
        lat: 55.8182,
        lng: 37.4352,
        order: 3,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.160',
        name: 'Щукинская',
        lat: 55.8094,
        lng: 37.463241,
        order: 4,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.95',
        name: 'Октябрьское поле',
        lat: 55.793581,
        lng: 37.493317,
        order: 5,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.114',
        name: 'Полежаевская',
        lat: 55.777201,
        lng: 37.517895,
        order: 6,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.18',
        name: 'Беговая',
        lat: 55.773505,
        lng: 37.545518,
        order: 7,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.146',
        name: 'Улица 1905 года',
        lat: 55.763944,
        lng: 37.562271,
        order: 8,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.16',
        name: 'Баррикадная',
        lat: 55.760793,
        lng: 37.581242,
        order: 9,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.124',
        name: 'Пушкинская',
        lat: 55.765607,
        lng: 37.604356,
        order: 10,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.67',
        name: 'Кузнецкий мост',
        lat: 55.761498,
        lng: 37.624423,
        order: 11,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.51',
        name: 'Китай-город',
        lat: 55.75436,
        lng: 37.633877,
        order: 12,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.77',
        name: 'Таганская',
        lat: 55.739502,
        lng: 37.653605,
        order: 13,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.62',
        name: 'Пролетарская',
        lat: 55.731546,
        lng: 37.666917,
        order: 14,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.31',
        name: 'Волгоградский проспект',
        lat: 55.725546,
        lng: 37.685197,
        order: 15,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.139',
        name: 'Текстильщики',
        lat: 55.709211,
        lng: 37.732117,
        order: 16,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.68',
        name: 'Кузьминки',
        lat: 55.705493,
        lng: 37.763295,
        order: 17,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.127',
        name: 'Рязанский проспект',
        lat: 55.716139,
        lng: 37.792694,
        order: 18,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.33',
        name: 'Выхино',
        lat: 55.715983,
        lng: 37.816788,
        order: 19,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.464',
        name: 'Лермонтовский проспект',
        lat: 55.702036,
        lng: 37.851044,
        order: 20,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.465',
        name: 'Жулебино',
        lat: 55.684722,
        lng: 37.855833,
        order: 21,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
      {
        id: '7.508',
        name: 'Котельники',
        lat: 55.6743,
        lng: 37.8582,
        order: 22,
        line: {
          id: '7',
          hex_color: '943E90',
          name: 'Таганско-Краснопресненская',
        },
      },
    ],
  },
  {
    id: '5',
    hex_color: '915133',
    name: 'Кольцевая',
    stations: [
      {
        id: '5.82',
        name: 'Новослободская',
        lat: 55.779606,
        lng: 37.601252,
        order: 0,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.119',
        name: 'Проспект Мира',
        lat: 55.779584,
        lng: 37.633646,
        order: 1,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.55',
        name: 'Комсомольская',
        lat: 55.775672,
        lng: 37.654772,
        order: 2,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.71',
        name: 'Курская',
        lat: 55.758631,
        lng: 37.661059,
        order: 3,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.76',
        name: 'Таганская',
        lat: 55.742396,
        lng: 37.653334,
        order: 4,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.102',
        name: 'Павелецкая',
        lat: 55.731414,
        lng: 37.636294,
        order: 5,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.36',
        name: 'Добрынинская',
        lat: 55.728994,
        lng: 37.622533,
        order: 6,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.93',
        name: 'Октябрьская',
        lat: 55.729264,
        lng: 37.611049,
        order: 7,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.104',
        name: 'Парк культуры',
        lat: 55.735221,
        lng: 37.593095,
        order: 8,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.49',
        name: 'Киевская',
        lat: 55.74361,
        lng: 37.56735,
        order: 10,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.58',
        name: 'Краснопресненская',
        lat: 55.760378,
        lng: 37.577114,
        order: 11,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
      {
        id: '5.20',
        name: 'Белорусская',
        lat: 55.775179,
        lng: 37.582303,
        order: 12,
        line: {
          id: '5',
          hex_color: '915133',
          name: 'Кольцевая',
        },
      },
    ],
  },
  {
    id: '10',
    hex_color: 'BED12C',
    name: 'Люблинско-Дмитровская',
    stations: [
      {
        id: '10.833',
        name: 'Физтех',
        lat: 55.921389,
        lng: 37.546389,
        order: 0,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.834',
        name: 'Лианозово',
        lat: 55.931111,
        lng: 37.543611,
        order: 1,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.835',
        name: 'Яхромская',
        lat: 55.8775,
        lng: 37.545833,
        order: 2,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.597',
        name: 'Селигерская',
        lat: 55.86483,
        lng: 37.55005,
        order: 3,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.598',
        name: 'Верхние Лихоборы',
        lat: 55.85566,
        lng: 37.56282,
        order: 4,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.596',
        name: 'Окружная',
        lat: 55.848889,
        lng: 37.571111,
        order: 5,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.548',
        name: 'Петровско-Разумовская',
        lat: 55.836667,
        lng: 37.575556,
        order: 6,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.547',
        name: 'Фонвизинская',
        lat: 55.822778,
        lng: 37.588056,
        order: 7,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.546',
        name: 'Бутырская ',
        lat: 55.813333,
        lng: 37.602778,
        order: 8,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.185',
        name: 'Марьина Роща',
        lat: 55.793723,
        lng: 37.61618,
        order: 9,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.184',
        name: 'Достоевская',
        lat: 55.781667,
        lng: 37.613889,
        order: 10,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.177',
        name: 'Трубная',
        lat: 55.76771,
        lng: 37.621926,
        order: 11,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.175',
        name: 'Сретенский бульвар',
        lat: 55.766106,
        lng: 37.635688,
        order: 12,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.72',
        name: 'Чкаловская',
        lat: 55.755951,
        lng: 37.659293,
        order: 13,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.113',
        name: 'Римская',
        lat: 55.747027,
        lng: 37.679996,
        order: 14,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.63',
        name: 'Крестьянская застава',
        lat: 55.732278,
        lng: 37.665325,
        order: 15,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.39',
        name: 'Дубровка',
        lat: 55.71807,
        lng: 37.676259,
        order: 16,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.52',
        name: 'Кожуховская',
        lat: 55.706156,
        lng: 37.68544,
        order: 17,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.109',
        name: 'Печатники',
        lat: 55.692921,
        lng: 37.728338,
        order: 18,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.32',
        name: 'Волжская',
        lat: 55.690446,
        lng: 37.754314,
        order: 19,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.75',
        name: 'Люблино',
        lat: 55.676596,
        lng: 37.761639,
        order: 20,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.25',
        name: 'Братиславская',
        lat: 55.658817,
        lng: 37.748415,
        order: 21,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.79',
        name: 'Марьино',
        lat: 55.649158,
        lng: 37.743844,
        order: 22,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.187',
        name: 'Борисово',
        lat: 55.6325,
        lng: 37.743333,
        order: 23,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.188',
        name: 'Шипиловская',
        lat: 55.621667,
        lng: 37.743611,
        order: 24,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
      {
        id: '10.186',
        name: 'Зябликово',
        lat: 55.611944,
        lng: 37.745278,
        order: 25,
        line: {
          id: '10',
          hex_color: 'BED12C',
          name: 'Люблинско-Дмитровская',
        },
      },
    ],
  },
  {
    id: '11',
    hex_color: '88CDCF',
    name: 'Каховская',
    stations: [
      {
        id: '11.46',
        name: 'Каширская',
        lat: 55.654327,
        lng: 37.647705,
        order: 0,
        line: {
          id: '11',
          hex_color: '88CDCF',
          name: 'Каховская',
        },
      },
      {
        id: '11.26',
        name: 'Варшавская',
        lat: 55.653294,
        lng: 37.619522,
        order: 1,
        line: {
          id: '11',
          hex_color: '88CDCF',
          name: 'Каховская',
        },
      },
      {
        id: '11.44',
        name: 'Каховская',
        lat: 55.652923,
        lng: 37.596573,
        order: 2,
        line: {
          id: '11',
          hex_color: '88CDCF',
          name: 'Каховская',
        },
      },
    ],
  },
  {
    id: '12',
    hex_color: 'BAC8E8',
    name: 'Бутовская',
    stations: [
      {
        id: '12.167',
        name: 'Бунинская аллея',
        lat: 55.537977,
        lng: 37.515899,
        order: 0,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.168',
        name: 'Улица Горчакова',
        lat: 55.542281,
        lng: 37.532063,
        order: 1,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.169',
        name: 'Бульвар Адмирала Ушакова',
        lat: 55.545207,
        lng: 37.542329,
        order: 2,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.166',
        name: 'Улица Скобелевская',
        lat: 55.548103,
        lng: 37.552721,
        order: 3,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.171',
        name: 'Улица Старокачаловская',
        lat: 55.569194,
        lng: 37.576074,
        order: 4,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.466',
        name: 'Лесопарковая',
        lat: 55.581656,
        lng: 37.577816,
        order: 5,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
      {
        id: '12.467',
        name: 'Битцевский Парк',
        lat: 55.600066,
        lng: 37.556058,
        order: 6,
        line: {
          id: '12',
          hex_color: 'BAC8E8',
          name: 'Бутовская',
        },
      },
    ],
  },
  {
    id: '133',
    hex_color: 'FFCD1C',
    name: 'Солнцевская',
    stations: [
      {
        id: '133.468',
        name: 'Деловой центр',
        lat: 55.7491,
        lng: 37.5395,
        order: 12,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.885',
        name: 'Пыхтино',
        lat: 55.625,
        lng: 37.298056,
        order: 12,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.470',
        name: 'Парк Победы',
        lat: 55.736478,
        lng: 37.514401,
        order: 13,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.555',
        name: 'Минская',
        lat: 55.7232,
        lng: 37.5038,
        order: 14,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.556',
        name: 'Ломоносовский проспект',
        lat: 55.7055,
        lng: 37.5225,
        order: 15,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.557',
        name: 'Раменки',
        lat: 55.6961,
        lng: 37.505,
        order: 16,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.607',
        name: 'Мичуринский проспект',
        lat: 55.6888,
        lng: 37.485,
        order: 17,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.608',
        name: 'Озёрная',
        lat: 55.6698,
        lng: 37.4495,
        order: 18,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.609',
        name: 'Говорово',
        lat: 55.6588,
        lng: 37.4174,
        order: 19,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.610',
        name: 'Солнцево',
        lat: 55.649,
        lng: 37.3911,
        order: 20,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.611',
        name: 'Боровское шоссе',
        lat: 55.647,
        lng: 37.3701,
        order: 21,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.612',
        name: 'Новопеределкино',
        lat: 55.6385,
        lng: 37.3544,
        order: 22,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
      {
        id: '133.613',
        name: 'Рассказовка',
        lat: 55.6324,
        lng: 37.3328,
        order: 23,
        line: {
          id: '133',
          hex_color: 'FFCD1C',
          name: 'Солнцевская',
        },
      },
    ],
  },
  {
    id: '95',
    hex_color: 'CC4C6E',
    name: 'МЦК',
    stations: [
      {
        id: '95.515',
        name: 'Окружная',
        lat: 55.848889,
        lng: 37.571111,
        order: 0,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.516',
        name: 'Владыкино',
        lat: 55.847222,
        lng: 37.591944,
        order: 1,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.517',
        name: 'Ботанический сад',
        lat: 55.845556,
        lng: 37.640278,
        order: 2,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.518',
        name: 'Ростокино',
        lat: 55.839444,
        lng: 37.667778,
        order: 3,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.519',
        name: 'Белокаменная',
        lat: 55.83,
        lng: 37.700556,
        order: 4,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.520',
        name: 'Бульвар Рокоссовского',
        lat: 55.817222,
        lng: 37.736944,
        order: 5,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.521',
        name: 'Локомотив',
        lat: 55.803219,
        lng: 37.745742,
        order: 6,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.522',
        name: 'Измайлово',
        lat: 55.788611,
        lng: 37.742778,
        order: 7,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.523',
        name: 'Соколиная Гора',
        lat: 55.77,
        lng: 37.745278,
        order: 8,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.524',
        name: 'Шоссе Энтузиастов',
        lat: 55.758633,
        lng: 37.748477,
        order: 9,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.525',
        name: 'Андроновка',
        lat: 55.741111,
        lng: 37.734444,
        order: 10,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.526',
        name: 'Нижегородская',
        lat: 55.732222,
        lng: 37.72825,
        order: 11,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.527',
        name: 'Новохохловская',
        lat: 55.723889,
        lng: 37.716111,
        order: 12,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.528',
        name: 'Угрешская',
        lat: 55.718333,
        lng: 37.697778,
        order: 13,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.529',
        name: 'Дубровка',
        lat: 55.71268,
        lng: 37.677775,
        order: 14,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.530',
        name: 'Автозаводская',
        lat: 55.70631,
        lng: 37.66314,
        order: 15,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.531',
        name: 'ЗИЛ',
        lat: 55.698333,
        lng: 37.648333,
        order: 16,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.532',
        name: 'Верхние Котлы',
        lat: 55.69,
        lng: 37.618889,
        order: 17,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.533',
        name: 'Крымская',
        lat: 55.690038,
        lng: 37.605,
        order: 18,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.534',
        name: 'Площадь Гагарина',
        lat: 55.706944,
        lng: 37.585833,
        order: 19,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.535',
        name: 'Лужники',
        lat: 55.720278,
        lng: 37.563056,
        order: 20,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.536',
        name: 'Кутузовская',
        lat: 55.740833,
        lng: 37.533333,
        order: 21,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.537',
        name: 'Деловой центр',
        lat: 55.747222,
        lng: 37.532222,
        order: 22,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.538',
        name: 'Шелепиха',
        lat: 55.7575,
        lng: 37.525556,
        order: 23,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.539',
        name: 'Хорошево',
        lat: 55.777222,
        lng: 37.507222,
        order: 24,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.540',
        name: 'Зорге',
        lat: 55.787778,
        lng: 37.504444,
        order: 25,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.541',
        name: 'Панфиловская',
        lat: 55.799167,
        lng: 37.498889,
        order: 26,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.542',
        name: 'Стрешнево',
        lat: 55.813611,
        lng: 37.486944,
        order: 27,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.543',
        name: 'Балтийская',
        lat: 55.825833,
        lng: 37.496111,
        order: 28,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.544',
        name: 'Коптево',
        lat: 55.839637,
        lng: 37.520037,
        order: 29,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
      {
        id: '95.545',
        name: 'Лихоборы',
        lat: 55.847222,
        lng: 37.551389,
        order: 30,
        line: {
          id: '95',
          hex_color: 'CC4C6E',
          name: 'МЦК',
        },
      },
    ],
  },
  {
    id: '96',
    hex_color: '006DA8',
    name: 'Монорельс',
    stations: [
      {
        id: '96.549',
        name: 'Тимирязевская',
        lat: 55.819049,
        lng: 37.578882,
        order: 0,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
      {
        id: '96.550',
        name: 'Улица Милашенкова',
        lat: 55.821876,
        lng: 37.591206,
        order: 1,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
      {
        id: '96.551',
        name: 'Телецентр',
        lat: 55.821795,
        lng: 37.608975,
        order: 2,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
      {
        id: '96.552',
        name: 'Улица Академика Королёва',
        lat: 55.821821,
        lng: 37.627167,
        order: 3,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
      {
        id: '96.553',
        name: 'Выставочный центр',
        lat: 55.824086,
        lng: 37.638494,
        order: 4,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
      {
        id: '96.554',
        name: 'Улица Сергея Эйзенштейна',
        lat: 55.829305,
        lng: 37.644997,
        order: 5,
        line: {
          id: '96',
          hex_color: '006DA8',
          name: 'Монорельс',
        },
      },
    ],
  },
  {
    id: '97',
    hex_color: '88CDCF',
    name: 'Большая кольцевая линия',
    stations: [
      {
        id: '97.813',
        name: 'Мичуринский проспект',
        lat: 55.688333,
        lng: 37.485,
        order: 0,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.814',
        name: 'Проспект Вернадского',
        lat: 55.677778,
        lng: 37.505,
        order: 1,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.815',
        name: 'Новаторская',
        lat: 55.670833,
        lng: 37.52,
        order: 2,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.816',
        name: 'Воронцовская',
        lat: 55.658333,
        lng: 37.540833,
        order: 3,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.817',
        name: 'Зюзино',
        lat: 55.655158,
        lng: 37.575786,
        order: 4,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.818',
        name: 'Каховская',
        lat: 55.653056,
        lng: 37.598333,
        order: 5,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.824',
        name: 'Варшавская',
        lat: 55.653333,
        lng: 37.619444,
        order: 6,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.832',
        name: 'Каширская',
        lat: 55.655,
        lng: 37.648611,
        order: 7,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.831',
        name: 'Кленовый бульвар',
        lat: 55.674444,
        lng: 37.680833,
        order: 8,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.830',
        name: 'Нагатинский Затон',
        lat: 55.684444,
        lng: 37.703611,
        order: 9,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.829',
        name: 'Печатники',
        lat: 55.694722,
        lng: 37.7275,
        order: 10,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.828',
        name: 'Текстильщики',
        lat: 55.708333,
        lng: 37.728333,
        order: 11,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.827',
        name: 'Нижегородская',
        lat: 55.7325,
        lng: 37.728611,
        order: 12,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.826',
        name: 'Авиамоторная',
        lat: 55.753056,
        lng: 37.718611,
        order: 13,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.825',
        name: 'Лефортово',
        lat: 55.764444,
        lng: 37.702778,
        order: 14,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.803',
        name: 'Электрозаводская',
        lat: 55.782057,
        lng: 37.7053,
        order: 15,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.823',
        name: 'Сокольники',
        lat: 55.791111,
        lng: 37.678889,
        order: 16,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.822',
        name: 'Рижская',
        lat: 55.792222,
        lng: 37.633889,
        order: 17,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.821',
        name: 'Марьина Роща',
        lat: 55.798333,
        lng: 37.617222,
        order: 18,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.685',
        name: 'Савёловская',
        lat: 55.794054,
        lng: 37.587163,
        order: 19,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.599',
        name: 'Петровский парк',
        lat: 55.79233,
        lng: 37.55952,
        order: 20,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.600',
        name: 'ЦСКА',
        lat: 55.78643,
        lng: 37.53502,
        order: 21,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.601',
        name: 'Хорошевская',
        lat: 55.77643,
        lng: 37.51981,
        order: 22,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.602',
        name: 'Шелепиха',
        lat: 55.75723,
        lng: 37.52571,
        order: 23,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.603',
        name: 'Деловой центр',
        lat: 55.7491,
        lng: 37.5395,
        order: 24,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.806',
        name: 'Народное Ополчение',
        lat: 55.775278,
        lng: 39.484444,
        order: 25,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.805',
        name: 'Мнёвники',
        lat: 55.761153,
        lng: 37.47139,
        order: 26,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.809',
        name: 'Терехово',
        lat: 55.749167,
        lng: 38.460556,
        order: 27,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.810',
        name: 'Кунцевская',
        lat: 55.730278,
        lng: 37.445833,
        order: 28,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.811',
        name: 'Давыдково',
        lat: 55.765278,
        lng: 37.451667,
        order: 29,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
      {
        id: '97.812',
        name: 'Аминьевская',
        lat: 55.697222,
        lng: 37.464167,
        order: 30,
        line: {
          id: '97',
          hex_color: '88CDCF',
          name: 'Большая кольцевая линия',
        },
      },
    ],
  },
  {
    id: '98',
    hex_color: 'CC0066',
    name: 'Некрасовская',
    stations: [
      {
        id: '98.675',
        name: 'Косино',
        lat: 55.7026,
        lng: 37.8511,
        order: 0,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.676',
        name: 'Улица Дмитриевского',
        lat: 55.7093,
        lng: 37.8792,
        order: 1,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.677',
        name: 'Лухмановская',
        lat: 55.7078,
        lng: 37.9004,
        order: 2,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.641',
        name: 'Некрасовка',
        lat: 55.7029,
        lng: 37.9264,
        order: 3,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.762',
        name: 'Юго-Восточная',
        lat: 55.71,
        lng: 37.82,
        order: 4,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.763',
        name: 'Окская',
        lat: 55.72,
        lng: 37.77,
        order: 5,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.764',
        name: 'Стахановская',
        lat: 55.73,
        lng: 37.76,
        order: 6,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.765',
        name: 'Нижегородская',
        lat: 55.73,
        lng: 37.73,
        order: 7,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.800',
        name: 'Лефортово',
        lat: 55.764444,
        lng: 37.702778,
        order: 8,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.802',
        name: 'Электрозаводская',
        lat: 55.782057,
        lng: 37.7053,
        order: 9,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
      {
        id: '98.804',
        name: 'Авиамоторная',
        lat: 55.751933,
        lng: 37.717444,
        order: 10,
        line: {
          id: '98',
          hex_color: 'CC0066',
          name: 'Некрасовская',
        },
      },
    ],
  },
  {
    id: '131',
    hex_color: 'F5A528',
    name: 'МЦД - 1',
    stations: [
      {
        id: '131.687',
        name: 'Лобня',
        lat: 56.0048,
        lng: 37.29057,
        order: 0,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.688',
        name: 'Шереметьевская',
        lat: 55.983882,
        lng: 37.498752,
        order: 1,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.689',
        name: 'Хлебниково',
        lat: 55.970682,
        lng: 37.504638,
        order: 2,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.690',
        name: 'Водники',
        lat: 55.953419,
        lng: 37.511143,
        order: 3,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.691',
        name: 'Долгопрудная',
        lat: 55.938656,
        lng: 37.520542,
        order: 4,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.692',
        name: 'Новодачная',
        lat: 55.924459,
        lng: 37.527877,
        order: 5,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.693',
        name: 'Марк',
        lat: 55.904458,
        lng: 37.538242,
        order: 6,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.694',
        name: 'Лианозово',
        lat: 55.897316,
        lng: 37.553261,
        order: 7,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.695',
        name: 'Бескудниково',
        lat: 55.882713,
        lng: 37.567768,
        order: 8,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.696',
        name: 'Дегунино',
        lat: 55.86586,
        lng: 37.573235,
        order: 9,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.697',
        name: 'Окружная',
        lat: 55.848889,
        lng: 37.571111,
        order: 10,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.698',
        name: 'Тимирязевская',
        lat: 55.81866,
        lng: 37.574498,
        order: 11,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.699',
        name: 'Савёловская',
        lat: 55.793936,
        lng: 37.587038,
        order: 12,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.700',
        name: 'Белорусская',
        lat: 55.775179,
        lng: 37.582303,
        order: 13,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.701',
        name: 'Беговая',
        lat: 55.773505,
        lng: 37.545518,
        order: 14,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.702',
        name: 'Тестовская',
        lat: 55.754292,
        lng: 37.531551,
        order: 15,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.703',
        name: 'Фили',
        lat: 55.744263,
        lng: 37.514526,
        order: 16,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.801',
        name: 'Славянский бульвар',
        lat: 55.729722,
        lng: 37.470556,
        order: 17,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.704',
        name: 'Кунцевская',
        lat: 55.730554,
        lng: 37.445591,
        order: 18,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.705',
        name: 'Рабочий Посёлок',
        lat: 55.726957,
        lng: 37.415577,
        order: 19,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.706',
        name: 'Сетунь',
        lat: 55.723713,
        lng: 37.397259,
        order: 20,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.707',
        name: 'Немчиновка',
        lat: 55.715668,
        lng: 37.374611,
        order: 21,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.708',
        name: 'Сколково',
        lat: 55.666801,
        lng: 37.424618,
        order: 22,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.709',
        name: 'Баковка',
        lat: 55.682816,
        lng: 37.315205,
        order: 23,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
      {
        id: '131.710',
        name: 'Одинцово',
        lat: 55.67798,
        lng: 37.27773,
        order: 24,
        line: {
          id: '131',
          hex_color: 'F5A528',
          name: 'МЦД - 1',
        },
      },
    ],
  },
  {
    id: '132',
    hex_color: 'E74683',
    name: 'МЦД - 2',
    stations: [
      {
        id: '132.711',
        name: 'Нахабино',
        lat: 55.841522,
        lng: 37.185204,
        order: 0,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.712',
        name: 'Аникеевка',
        lat: 55.832099,
        lng: 37.219829,
        order: 1,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.713',
        name: 'Опалиха',
        lat: 55.82333,
        lng: 37.246843,
        order: 2,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.714',
        name: 'Красногорская',
        lat: 55.814571,
        lng: 37.303337,
        order: 3,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.715',
        name: 'Павшино',
        lat: 55.815231,
        lng: 37.341461,
        order: 4,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.716',
        name: 'Пенягино',
        lat: 55.822539,
        lng: 37.361049,
        order: 5,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.717',
        name: 'Волоколамская',
        lat: 55.835154,
        lng: 37.382453,
        order: 6,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.744',
        name: 'Трикотажная',
        lat: 55.833137,
        lng: 37.398967,
        order: 7,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.718',
        name: 'Тушинская',
        lat: 55.825479,
        lng: 37.437024,
        order: 8,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.719',
        name: 'Покровское-Стрешнево',
        lat: 55.814247,
        lng: 37.47678,
        order: 9,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.720',
        name: 'Стрешнево',
        lat: 55.813611,
        lng: 37.486944,
        order: 10,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.721',
        name: 'Красный Балтиец',
        lat: 55.815514,
        lng: 37.526367,
        order: 11,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.722',
        name: 'Гражданская',
        lat: 55.805527,
        lng: 37.55315,
        order: 12,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.723',
        name: 'Дмитровская',
        lat: 55.808056,
        lng: 37.581734,
        order: 13,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.724',
        name: 'Рижская',
        lat: 55.792494,
        lng: 37.636114,
        order: 14,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.725',
        name: 'Каланчёвская',
        lat: 55.77667,
        lng: 37.65111,
        order: 15,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.726',
        name: 'Курская',
        lat: 55.757622,
        lng: 37.660767,
        order: 16,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.727',
        name: 'Москва Товарная',
        lat: 55.745358,
        lng: 37.688839,
        order: 17,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.728',
        name: 'Калитники',
        lat: 55.733981,
        lng: 37.702203,
        order: 18,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.729',
        name: 'Новохохловская',
        lat: 55.718523,
        lng: 37.719236,
        order: 19,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.730',
        name: 'Текстильщики',
        lat: 55.708934,
        lng: 37.731283,
        order: 20,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.731',
        name: 'Люблино',
        lat: 55.676596,
        lng: 37.761639,
        order: 21,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.732',
        name: 'Депо',
        lat: 55.674257,
        lng: 37.728446,
        order: 22,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.733',
        name: 'Перерва',
        lat: 55.660809,
        lng: 37.716278,
        order: 23,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.807',
        name: 'Курьяново',
        lat: 55.649722,
        lng: 37.701667,
        order: 24,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.734',
        name: 'Москворечье',
        lat: 55.641239,
        lng: 37.689789,
        order: 25,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.735',
        name: 'Царицыно',
        lat: 55.618309,
        lng: 37.668846,
        order: 26,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.736',
        name: 'Покровское',
        lat: 55.814247,
        lng: 37.47678,
        order: 27,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.737',
        name: 'Красный строитель',
        lat: 55.589455,
        lng: 37.615093,
        order: 28,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.738',
        name: 'Битца',
        lat: 55.571186,
        lng: 37.611443,
        order: 29,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.739',
        name: 'Бутово',
        lat: 55.548279,
        lng: 37.555668,
        order: 30,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.740',
        name: 'Щербинка',
        lat: 55.509724,
        lng: 37.562008,
        order: 31,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.741',
        name: 'Остафьево',
        lat: 55.50337,
        lng: 37.520055,
        order: 32,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.742',
        name: 'Силикатная',
        lat: 55.470278,
        lng: 37.555278,
        order: 33,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
      {
        id: '132.743',
        name: 'Подольск',
        lat: 55.431667,
        lng: 37.565,
        order: 34,
        line: {
          id: '132',
          hex_color: 'E74683',
          name: 'МЦД - 2',
        },
      },
    ],
  },
  {
    id: '135',
    hex_color: 'EA5B04',
    name: 'МЦД-3',
    stations: [
      {
        id: '135.836',
        name: 'Крюково',
        lat: 55.979722,
        lng: 37.173611,
        order: 0,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.837',
        name: 'Малино',
        lat: 55.969167,
        lng: 37.211667,
        order: 1,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.838',
        name: 'Фирсановская',
        lat: 55.960278,
        lng: 37.251111,
        order: 2,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.839',
        name: 'Сходня',
        lat: 55.949722,
        lng: 37.298611,
        order: 3,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.840',
        name: 'Подрезково',
        lat: 55.941667,
        lng: 37.334722,
        order: 4,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.841',
        name: 'Новоподрезково',
        lat: 55.936389,
        lng: 37.351667,
        order: 5,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.842',
        name: 'Молжаниново',
        lat: 55.924167,
        lng: 37.380833,
        order: 6,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.843',
        name: 'Химки',
        lat: 55.894444,
        lng: 37.450833,
        order: 7,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.844',
        name: 'Левобережная',
        lat: 55.886944,
        lng: 37.468611,
        order: 8,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.845',
        name: 'Ховрино',
        lat: 55.879444,
        lng: 37.486667,
        order: 9,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.846',
        name: 'Грачёвская',
        lat: 55.869444,
        lng: 37.509167,
        order: 10,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.847',
        name: 'Моссельмаш',
        lat: 55.862222,
        lng: 37.526389,
        order: 11,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.848',
        name: 'Лихоборы',
        lat: 55.85,
        lng: 37.5525,
        order: 12,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.849',
        name: 'Петровско-Разумовская',
        lat: 55.839722,
        lng: 37.568333,
        order: 13,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.850',
        name: 'Останкино',
        lat: 55.817222,
        lng: 37.603611,
        order: 14,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.851',
        name: 'Рижская',
        lat: 55.796944,
        lng: 37.639167,
        order: 15,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.852',
        name: 'Митьково',
        lat: 55.786389,
        lng: 37.6675,
        order: 16,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.853',
        name: 'Электрозаводская',
        lat: 55.781111,
        lng: 37.705278,
        order: 17,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.854',
        name: 'Сортировочная',
        lat: 55.763611,
        lng: 37.720833,
        order: 18,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.855',
        name: 'Авиамоторная',
        lat: 55.750278,
        lng: 37.721944,
        order: 19,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.856',
        name: 'Андроновка',
        lat: 55.744444,
        lng: 37.741111,
        order: 20,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.857',
        name: 'Перово',
        lat: 55.735556,
        lng: 37.765,
        order: 21,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.858',
        name: 'Плющево',
        lat: 55.730556,
        lng: 37.774167,
        order: 22,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.859',
        name: 'Вешняки',
        lat: 55.721944,
        lng: 37.799167,
        order: 23,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.860',
        name: 'Выхино',
        lat: 55.88,
        lng: 37.816667,
        order: 24,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.861',
        name: 'Косино',
        lat: 55.714167,
        lng: 37.8475,
        order: 25,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.862',
        name: 'Ухтомская',
        lat: 55.698611,
        lng: 37.864167,
        order: 26,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.863',
        name: 'Люберцы I',
        lat: 55.681667,
        lng: 37.896944,
        order: 27,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.864',
        name: 'Панки',
        lat: 55.668889,
        lng: 37.9225,
        order: 28,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.865',
        name: 'Томилино',
        lat: 55.655,
        lng: 37.954722,
        order: 29,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.866',
        name: 'Красково',
        lat: 55.649722,
        lng: 37.9825,
        order: 30,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.867',
        name: 'Малаховка',
        lat: 55.645,
        lng: 38.008333,
        order: 31,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.868',
        name: 'Удельная',
        lat: 55.634444,
        lng: 38.043889,
        order: 32,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.869',
        name: 'Быково',
        lat: 55.626667,
        lng: 38.070556,
        order: 33,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.870',
        name: 'Ильинская',
        lat: 55.616389,
        lng: 38.100278,
        order: 34,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.871',
        name: 'Отдых',
        lat: 55.601111,
        lng: 38.136944,
        order: 35,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.872',
        name: 'Кратово',
        lat: 55.591667,
        lng: 38.16,
        order: 36,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.873',
        name: 'Есенинская',
        lat: 55.581944,
        lng: 38.184167,
        order: 37,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.874',
        name: 'Фабричная',
        lat: 55.572778,
        lng: 1.873333,
        order: 38,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.875',
        name: 'Раменское',
        lat: 55.565278,
        lng: 55.565278,
        order: 39,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
      {
        id: '135.876',
        name: 'Ипподром',
        lat: 55.560278,
        lng: 38.238889,
        order: 40,
        line: {
          id: '135',
          hex_color: 'EA5B04',
          name: 'МЦД-3',
        },
      },
    ],
  },
  {
    id: '136',
    hex_color: '00CC66',
    name: 'МЦД-4',
    stations: [
      {
        id: '136.877',
        name: 'Железнодорожная',
        lat: 55.7525,
        lng: 38.008889,
        order: 0,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.878',
        name: 'Ольгино',
        lat: 55.751667,
        lng: 37.978611,
        order: 1,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.879',
        name: 'Кучино',
        lat: 55.752222,
        lng: 37.954722,
        order: 2,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.880',
        name: 'Салтыковская',
        lat: 55.757778,
        lng: 37.923056,
        order: 3,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.881',
        name: 'Никольское',
        lat: 55.759722,
        lng: 37.897778,
        order: 4,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.882',
        name: 'Реутово',
        lat: 55.751389,
        lng: 37.855833,
        order: 5,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.883',
        name: 'Новогиреево',
        lat: 55.744444,
        lng: 37.818333,
        order: 6,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.884',
        name: 'Кусково',
        lat: 55.739722,
        lng: 37.795278,
        order: 7,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.886',
        name: 'Чухлинка',
        lat: 55.733889,
        lng: 55.733889,
        order: 8,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.887',
        name: 'Нижегородская',
        lat: 55.733333,
        lng: 37.729444,
        order: 9,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.888',
        name: 'Серп и Молот',
        lat: 55.748056,
        lng: 37.681944,
        order: 10,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.889',
        name: 'Курский вокзал',
        lat: 55.740833,
        lng: 37.660556,
        order: 11,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.890',
        name: 'Площадь трёх вокзалов',
        lat: 55.776667,
        lng: 37.651111,
        order: 12,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.891',
        name: 'Рижская',
        lat: 55.793889,
        lng: 37.638611,
        order: 13,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.892',
        name: 'Марьина Роща',
        lat: 55.800833,
        lng: 37.618889,
        order: 14,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.893',
        name: 'Савёловская',
        lat: 55.794444,
        lng: 37.590278,
        order: 15,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.894',
        name: 'Белорусский вокзал',
        lat: 55.776389,
        lng: 37.580278,
        order: 16,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.895',
        name: 'Беговая',
        lat: 55.770833,
        lng: 55.770833,
        order: 17,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.896',
        name: 'Ермакова Роща',
        lat: 55.765556,
        lng: 37.535278,
        order: 18,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.897',
        name: 'Тестовская',
        lat: 55.750833,
        lng: 37.530278,
        order: 19,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.898',
        name: 'Кутузовская',
        lat: 55.741944,
        lng: 37.533056,
        order: 20,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.899',
        name: 'Поклонная',
        lat: 55.728333,
        lng: 37.511667,
        order: 21,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.900',
        name: 'Минская',
        lat: 55.723333,
        lng: 37.533056,
        order: 22,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.901',
        name: 'Матвеевское',
        lat: 55.704722,
        lng: 37.482222,
        order: 23,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.902',
        name: 'Аминьевская',
        lat: 55.699444,
        lng: 37.468056,
        order: 24,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.903',
        name: 'Очаково I',
        lat: 55.683611,
        lng: 37.451389,
        order: 25,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.904',
        name: 'Мещерская',
        lat: 55.666667,
        lng: 37.424444,
        order: 26,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.905',
        name: 'Солнечная',
        lat: 55.656944,
        lng: 37.383611,
        order: 27,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.906',
        name: 'Новопеределкино',
        lat: 55.639167,
        lng: 37.381111,
        order: 28,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.907',
        name: 'Переделкино',
        lat: 55.656111,
        lng: 37.353889,
        order: 29,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.908',
        name: 'Мичуринец',
        lat: 55.646111,
        lng: 37.315,
        order: 30,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.909',
        name: 'Внуково',
        lat: 55.648889,
        lng: 37.269722,
        order: 31,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.910',
        name: 'Лесной Городок',
        lat: 55.630278,
        lng: 37.219167,
        order: 32,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.911',
        name: 'Толстопальцево',
        lat: 55.607778,
        lng: 37.186389,
        order: 33,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.912',
        name: 'Кокошкино',
        lat: 55.599722,
        lng: 37.171389,
        order: 34,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.913',
        name: 'Санино',
        lat: 55.583889,
        lng: 37.138333,
        order: 35,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.914',
        name: 'Крёкшино',
        lat: 55.577778,
        lng: 37.109722,
        order: 36,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.915',
        name: 'Победа',
        lat: 55.566111,
        lng: 37.093056,
        order: 37,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
      {
        id: '136.916',
        name: 'Апрелевка',
        lat: 55.550278,
        lng: 37.0675,
        order: 38,
        line: {
          id: '136',
          hex_color: '00CC66',
          name: 'МЦД-4',
        },
      },
    ],
  },
];
